import { Component, inject, Input, OnDestroy, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { SynlabHeaderService } from '../../../../../../../synlab-access-ui-components/synlab-header/synlab-header.service';
import { AsyncPipe } from '@angular/common';
import { TranslocoModule } from '@jsverse/transloco';
import { Subject } from 'rxjs';
import { RouterLink } from '@angular/router';
import { LayoutService } from '../layout-service/layout.service';

@Component({
    selector: 'app-right-sidebar-menu',
    imports: [MatIconModule, AsyncPipe, TranslocoModule, RouterLink],
    templateUrl: './right-sidebar-menu.component.html',
    styleUrl: './right-sidebar-menu.component.scss'
})
export class RightSidebarMenuComponent implements OnInit, OnDestroy {

  public readonly headerService = inject(SynlabHeaderService);

  public readonly layoutService = inject(LayoutService);

  public readonly showRightSidebar = this.layoutService.showRightSidebar;

  public readonly sidebarView = this.layoutService.sidebar;

  public readonly links$ = this.headerService.links$;

  @Input()
  public currentLangCode: string = '';

  private readonly onDestroy$ = new Subject<void>();

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
  }

  public showProfile() {
    this.showRightSidebar.set(false);
    setTimeout(() => {
      this.showRightSidebar.set(true);
      this.sidebarView.set('profile');
    }, 200);
  }

  /**
   * Query params for a routed link: the menu's own `langCode` plus whatever the
   * link declared for itself. The link wins on a clash, since it knows why it
   * set the param.
   */
  public routeQueryParams(link: { queryParams?: Record<string, string> }): Record<string, string> {
    return { langCode: this.currentLangCode, ...(link.queryParams ?? {}) };
  }

  public formatUrlWithLangCode(url: string | null) {
    if (!url) return url;

    const addQueryParam = (url: string, param: string, value: string) => {
      try {
        const urlObj = new URL(url);
        if (!urlObj.searchParams.has(param)) {
            urlObj.searchParams.append(param, value);
        }
        return urlObj.toString();
      } catch (error) {
        return url;
      }
    }

    return addQueryParam(url, 'langCode', this.currentLangCode);
  }

}
